export const CHAT_CONSTS = {
    UPDATE_OPEN_CHAT: "UPDATE_OPEN_CHAT",
    GET_SESSIONS: 'GET_SESSIONS',
    UPDATE_SELECTED_ID_SESSION: 'UPDATE_SELECTED_ID_SESSION',
    UPDATE_GLOBAL_CHAT: 'UPDATE_GLOBAL_CHAT',
    CLOSE_CHAT: 'CLOSE_CHAT',
    UPDATE_SEARCH_TEXT: 'UPDATE_SEARCH_TEXT'
};